/**
 * Lab Surveillance header / chart labels.
 * Competition (`m.c`) is often empty when league is unset — omit blanks so
 * Winner Name is not `— — Runner` and chart titles do not start with `-`.
 */

export function formatSurveillanceWinnerLabel(
  competition: string | null | undefined,
  winnerName: string | null | undefined,
): string {
  const parts = [competition, winnerName]
    .map((s) => String(s ?? '').trim())
    .filter(Boolean)
  return parts.join(' — ') || '—'
}

export function formatSurveillanceChartTitle(
  parts: Array<string | null | undefined>,
): string {
  return parts
    .map((s) => String(s ?? '').trim())
    .filter(Boolean)
    .join('-')
}
